<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="userForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="badgeNumber">Badge Number</label>
              <input type="text" class="form-control" formControlName="badgeNumber" id="badgeNumber" placeholder="Badge Number">
            </div>
            <div class="col-md-8 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="group">Group</label>
              <select id="group" class="form-control" formControlName="group">
                <option *ngFor="let group of groups" [value]="group">{{ group }}</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="cardNumber">Card Number</label>
              <input type="text" class="form-control" formControlName="cardNumber" id="cardNumber" placeholder="Card Number">
            </div>
            <div class="col-md-4 mb-3">
              <label for="pinCode">Pin Code</label>
              <input type="text" class="form-control" formControlName="pinCode" id="pinCode" placeholder="Pin Code">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <div class="form-check form-switch validity-checkbox">
                <input class="form-check-input" type="checkbox" id="validPeriod" formControlName="validPeriod">
                <label class="form-check-label" for="validPeriod">Set validity period</label>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="startDate" [dir]="languageService.getDir()">Start Date</label>
              <div class="input-group">
                <input type="text" id="startDate" name="startDate" class="form-control" placeholder="dd.mm.yyyy"
                       ngbDatepicker #sd="ngbDatepicker" firstDayOfWeek="0"
                       [minDate]="minDate" [dir]="languageService.getDir()"
                       formControlName="startDate">
                <button class="btn btn-outline-secondary calendar" (click)="sd.toggle()" type="button" [disabled]="sd.disabled">
                  <i class="fas fa-calendar"></i>
                </button>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="endDate" [dir]="languageService.getDir()">End Date</label>
              <div class="input-group">
                <input type="text" id="endDate" name="endDate" class="form-control" placeholder="dd.mm.yyyy"
                       ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0"
                       [minDate]="minDate" [dir]="languageService.getDir()"
                       formControlName="endDate">
                <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button" [disabled]="ed.disabled">
                  <i class="fas fa-calendar"></i>
                </button>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="privilege">Privilege</label>
              <select id="privilege" class="form-control" formControlName="privilege">
                <option *ngFor="let privilege of privileges" [value]="privilege">{{ privilege }}</option>
              </select>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(userForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
